import { dateFormat } from 'common/helpers/dateHelper';

const EventDate = (props) => {
  const { product, settings } = props;
  if (product.eventTicket?.eventDate) {
    return dateFormat(product.eventTicket.eventDate, settings);
  }
  return null;
};

export default EventDate;
